import { ANALISE_AUTOMATICA_STATUS } from '@/constants/analise/ConstantAnaliseAutomaticaStatus';
import { AG_INPUT_FIELD_PRESET } from '@/constants/components/ConstantAGInputFieldPreset';
import CLASSIFICACAO_ANALISE from '@/constants/ConstantClassificacaoAnalise';
import CLASSIFICACAO_ANALISE_SITUACAO from '@/constants/ConstantClassificacaoAnaliseSituacao';
import ETAPA_ANALISE from '@/constants/ConstantEtapaAnalise';
import MATRIZ_EXPOSICAO_IMPACTO from '@/constants/ConstantMatrizExposicaoImpacto';
import MATRIZ_EXPOSICAO_PRIORIDADE from '@/constants/ConstantMatrizExposicaoPrioridade';
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';
import NIVEL_RISCO from '@/constants/ConstantNivelRisco';
import RUBRICA_ANALISE_AUTOMATICA_STATUS from '@/constants/ConstantRubricaAnaliseAutomaticaStatus';
import STATUS_ANALISE from '@/constants/ConstantStatusAnalise';
import { isBoolean, isEmpty } from 'lodash';

export default class UtilsAnalise {
  static formatBooleanLabel(value, emptyText = null) {
    if (value === null || value === undefined) {
      return emptyText;
    }

    return value ? 'Sim' : 'Não';
  }

  static get ICON() {
    return Object.freeze({
      IN_ANALYSIS: { icon: 'md:info', color: 'feedback-information-medium', bgColor: 'feedback-information-light' },

      NOT_APPLICABLE: { icon: 'md:info', color: 'feedback-information-medium', bgColor: 'feedback-information-light' },

      NO_DATA: { icon: 'md:error', color: 'feedback-error-dark', bgColor: 'feedback-error-light' },

      WITHOUT_NOCIVE_AGENT: {
        icon: 'md:info',
        color: 'feedback-information-medium',
        bgColor: 'feedback-information-light',
      },
      WITH_NOCIVE_AGENT: { icon: 'md:info', color: 'feedback-error-medium', bgColor: 'feedback-error-light' },
    });
  }

  static get MESSAGE() {
    return Object.freeze({
      IN_ANALYSIS: 'Em análise',

      RECOMMENDATION: 'Recomendação Agnes',

      NOT_APPLICABLE: 'Não aplicável',

      CAMPO_EXCLUSIVO_ORGAO_PUBLICO: 'Campo exclusivo para órgão público',
      PREENCHIMENTO_OPCIONAL: 'Preenchimento opcional',

      EMPTY_FIELD: 'Campo sem preenchimento',
      EMPTY_OPTIONAL_FIELD: 'Campo opcional, sem preenchimento',

      XML_EMPTY_FIELD: 'Campo sem preenchimento no xml',

      MISSING_UNKNOW_EVENT: 'Ausência de evento de admissão, desligamento ou afastamento',

      S1010_EMPTY_FIELD: 'Campo sem preenchimento no S-1010',
      S1010_EMPTY_OPTIONAL_FIELD: 'Campo opcional, sem preenchimento no S-1010',

      S2200_NOT_FOUND: 'Ausência de dados, evento de admissão não localizado',

      S2240_NOT_FOUND: 'Ausência de dados, evento S-2240 não localizado',
      S2240_WITHOUT_NOCIVE_AGENT:
        'Ausência de agente nocivo ou de atividades previstas no Anexo IV do Decreto 3.048/1999',
      S2240_WITH_NOCIVE_AGENT: 'Há exposições',

      S3000_EXCLUSION: 'Excluído via S-3000',
    });
  }

  static getClassificacaoByEtapaAndGrauRisco(etapa, grauRisco) {
    if (!isEmpty(etapa) && !Object.keys(ETAPA_ANALISE).includes(etapa)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Etapa de Análise': ${etapa}`);
    }

    switch (etapa) {
      case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return CLASSIFICACAO_ANALISE.PENDENTE_DE_ESCLARECIMENTO;
      case ETAPA_ANALISE.ANALISADO:
        return UtilsAnalise.getClassificacaoByGrauRisco(grauRisco);
      default:
        return CLASSIFICACAO_ANALISE.EM_ANALISE;
    }
  }

  static getClassificacaoByGrauRisco(grauRisco) {
    if (!isEmpty(grauRisco) && !Object.keys(NIVEL_RISCO).includes(grauRisco)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Grau de Risco': ${grauRisco}`);
    }

    switch (grauRisco) {
      case NIVEL_RISCO.INEXPRESSIVO:
        return CLASSIFICACAO_ANALISE.INEXPRESSIVO;
      case NIVEL_RISCO.BAIXO:
      case NIVEL_RISCO.MODERADO:
      case NIVEL_RISCO.ELEVADO:
      case NIVEL_RISCO.CRITICO:
        return CLASSIFICACAO_ANALISE.RISCO_DETECTADO;
      default:
        return CLASSIFICACAO_ANALISE.EM_ANALISE;
    }
  }

  static getStatusByEtapa(etapa) {
    if (!isEmpty(etapa) && !Object.keys(ETAPA_ANALISE).includes(etapa)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Etapa de Análise': ${etapa}`);
    }

    switch (etapa) {
      case ETAPA_ANALISE.ANALISAR:
      case ETAPA_ANALISE.EM_ANALISE:
      case ETAPA_ANALISE.APTO_PARA_REVISAO:
      case ETAPA_ANALISE.REVISADO:
        return STATUS_ANALISE.EM_ANALISE;
      case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return STATUS_ANALISE.PENDENTE_DE_ESCLARECIMENTO;
      case ETAPA_ANALISE.ANALISADO:
        return STATUS_ANALISE.ANALISADO;
    }
  }

  static getDescriptionForStatus(status) {
    if (!isEmpty(status) && !Object.keys(STATUS_ANALISE).includes(status)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Status de Análise': ${status}`);
    }

    switch (status) {
      case STATUS_ANALISE.EM_ANALISE:
        return 'Em análise';
      case STATUS_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return 'Esclarecimento';
      case STATUS_ANALISE.ANALISADO:
        return 'Analisado';
    }
  }

  static getDescriptionForEtapa(etapa) {
    if (!isEmpty(etapa) && !Object.keys(ETAPA_ANALISE).includes(etapa)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Etapa de Análise': ${etapa}`);
    }

    switch (etapa) {
      case ETAPA_ANALISE.ANALISAR:
        return 'Analisar';
      case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return 'Esclarecimento';
      case ETAPA_ANALISE.EM_ANALISE:
        return 'Em análise';
      case ETAPA_ANALISE.APTO_PARA_REVISAO:
        return 'Apto para revisão';
      case ETAPA_ANALISE.REVISADO:
        return 'Revisado';
      case ETAPA_ANALISE.ANALISADO:
        return 'Analisado';
    }
  }

  static getDescriptionForGrauRisco(grauRisco) {
    if (!isEmpty(grauRisco) && !Object.keys(NIVEL_RISCO).includes(grauRisco)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Grau de Risco': ${grauRisco}`);
    }

    switch (grauRisco) {
      case NIVEL_RISCO.CRITICO:
        return 'Crítico';
      case NIVEL_RISCO.ELEVADO:
        return 'Elevado';
      case NIVEL_RISCO.MODERADO:
        return 'Moderado';
      case NIVEL_RISCO.BAIXO:
        return 'Baixo';
      case NIVEL_RISCO.INEXPRESSIVO:
        return 'Inexpressivo';
    }
  }

  static getColorForGrauRisco(grauRisco) {
    if (!isEmpty(grauRisco) && !Object.keys(NIVEL_RISCO).includes(grauRisco)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Grau de Risco': ${grauRisco}`);
    }

    switch (grauRisco) {
      case NIVEL_RISCO.CRITICO:
        return '#C73C44';
      case NIVEL_RISCO.ELEVADO:
        return '#E59245';
      case NIVEL_RISCO.MODERADO:
        return '#E5D545';
      case NIVEL_RISCO.BAIXO:
        return '#3CC79D';
      case NIVEL_RISCO.INEXPRESSIVO:
        return '#8686a2';
    }
  }

  static getColorForClassificacao(classificacao) {
    if (!isEmpty(classificacao) && !Object.keys(CLASSIFICACAO_ANALISE).includes(classificacao)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Classificação': ${classificacao}`);
    }

    switch (classificacao) {
      case CLASSIFICACAO_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return { backgroundColor: '#fae1fa', textColor: '#610051', borderColor: '#fae1fa' };
      case CLASSIFICACAO_ANALISE.EM_ANALISE:
        return { backgroundColor: '#8e8e9347', textColor: '#8e8e93', borderColor: '#8e8e9347' };
      case CLASSIFICACAO_ANALISE.RISCO_DETECTADO:
        return { backgroundColor: '#f5e5d2', textColor: '#c73c44', borderColor: '#f5e5d2' };
      case CLASSIFICACAO_ANALISE.INEXPRESSIVO:
        return {
          backgroundColor: 'rgb(var(--v-theme-lowDark))',
          textColor: '#52526b',
          borderColor: '#8686a2',
        };
      case CLASSIFICACAO_ANALISE.NAO_UTILIZADA:
        return { backgroundColor: '#d5d1e9', textColor: '#442d96', borderColor: '#d5d1e9' };
    }
  }

  static getDescriptionForClassificacao(classificacao) {
    if (!isEmpty(classificacao) && !Object.keys(CLASSIFICACAO_ANALISE).includes(classificacao)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Classificação': ${classificacao}`);
    }

    switch (classificacao) {
      case CLASSIFICACAO_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
        return 'Esclarecimento';
      case CLASSIFICACAO_ANALISE.EM_ANALISE:
        return 'Em análise';
      case CLASSIFICACAO_ANALISE.RISCO_DETECTADO:
        return 'Risco detectado';
      case CLASSIFICACAO_ANALISE.INEXPRESSIVO:
        return 'Inexpressivo';
      case CLASSIFICACAO_ANALISE.NAO_UTILIZADA:
        return 'Analisado';
    }
  }

  static getDescriptionForImpacto(impacto) {
    if (!isEmpty(impacto) && !Object.keys(MATRIZ_EXPOSICAO_IMPACTO).includes(impacto)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Impacto': ${impacto}`);
    }

    switch (impacto) {
      case MATRIZ_EXPOSICAO_IMPACTO.IRRELEVANTE:
        return 'Irrelevante';
      case MATRIZ_EXPOSICAO_IMPACTO.INSIGNIFICANTE:
        return 'Insignificante';
      case MATRIZ_EXPOSICAO_IMPACTO.MEDIO:
        return 'Médio';
      case MATRIZ_EXPOSICAO_IMPACTO.CRITICO:
        return 'Crítico';
      default:
        return null;
    }
  }

  static getDescriptionForPrioridade(prioridade) {
    if (!isEmpty(prioridade) && !Object.keys(MATRIZ_EXPOSICAO_PRIORIDADE).includes(prioridade)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Prioridade': ${prioridade}`);
    }

    switch (prioridade) {
      case MATRIZ_EXPOSICAO_PRIORIDADE.NULA:
        return 'Nula';
      case MATRIZ_EXPOSICAO_PRIORIDADE.BAIXA:
        return 'Baixa';
      case MATRIZ_EXPOSICAO_PRIORIDADE.MEDIA:
        return 'Média';
      case MATRIZ_EXPOSICAO_PRIORIDADE.ALTA:
        return 'Alta';
      default:
        return null;
    }
  }

  static getDescriptionForClassificacaoAnaliseSituacao(situacao) {
    if (!isEmpty(situacao) && !Object.keys(CLASSIFICACAO_ANALISE_SITUACAO).includes(situacao)) {
      console.error(`[UtilsAnalise] Valor inválido para 'Situação de Classificação de Análise': ${situacao}`);
    }

    switch (situacao) {
      case CLASSIFICACAO_ANALISE_SITUACAO.ATIVO:
        return 'Ativo';
      case CLASSIFICACAO_ANALISE_SITUACAO.INATIVO:
        return 'Inativo';
      default:
        return null;
    }
  }

  static getCodeAndNameOfItem(code, name, noDataText = null) {
    if (!code) return noDataText;

    let text = `${code}`;

    if (name) text += ` - ${name}`;

    return text;
  }

  static getStatusExibicao(valorOriginal, valorRecomendado, statusOriginal) {
    const devePularVerificacao = [
      ANALISE_AUTOMATICA_STATUS.OPCIONAL.getValue(),
      ANALISE_AUTOMATICA_STATUS.EXCECAO.getValue(),
      ANALISE_AUTOMATICA_STATUS.INVALIDO.getValue(),
      ANALISE_AUTOMATICA_STATUS.EXPIRADO.getValue(),
      ANALISE_AUTOMATICA_STATUS.INATIVO.getValue(),
      ANALISE_AUTOMATICA_STATUS.DUPLICADO.getValue(),
    ].includes(statusOriginal);

    if (devePularVerificacao) return statusOriginal;

    let haDivergencia = String(valorOriginal) !== String(valorRecomendado);

    // Caso específico para teto remuneratório
    if (isBoolean(valorOriginal) || isBoolean(valorRecomendado)) {
      haDivergencia = !!valorOriginal !== !!valorRecomendado;
    }

    if (!haDivergencia) return ANALISE_AUTOMATICA_STATUS.SEM_DIVERGENCIA.getValue();

    const haValorOriginal = valorOriginal !== null && valorOriginal !== undefined;
    const haValorRecomendado = valorRecomendado !== null && valorRecomendado !== undefined;

    return (haValorOriginal && !haValorRecomendado) || (haValorOriginal && haValorRecomendado && !haDivergencia)
      ? ANALISE_AUTOMATICA_STATUS.SEM_DIVERGENCIA.getValue()
      : ANALISE_AUTOMATICA_STATUS.DIVERGENTE.getValue();
  }

  /**
   * Retorna o estilo do campo (cor e dica) com base no status.
   *
   * @param {string} status - O status vindo de ANALISE_AUTOMATICA_STATUS.
   * @returns {{messageColor: string, hint: string}}
   */
  static getEstiloCampoPorStatus(status, impactoOriginal = null, impactoRecomendado = null) {
    let messageColor;
    let hint = status ? ANALISE_AUTOMATICA_STATUS.get(status).getDescription() : null;

    switch (status) {
      case ANALISE_AUTOMATICA_STATUS.OPCIONAL.getValue():
        messageColor = MESSAGE_COLOR.NEUTRAL;
        break;
      case ANALISE_AUTOMATICA_STATUS.EXCECAO.getValue():
        messageColor = MESSAGE_COLOR.INFORMATION;
        break;
      case ANALISE_AUTOMATICA_STATUS.INVALIDO.getValue():
        messageColor = MESSAGE_COLOR.ERROR;
        break;
      case ANALISE_AUTOMATICA_STATUS.EXPIRADO.getValue():
        messageColor = MESSAGE_COLOR.ERROR;
        break;
      case ANALISE_AUTOMATICA_STATUS.INATIVO.getValue():
        messageColor = MESSAGE_COLOR.ERROR;
        break;
      case ANALISE_AUTOMATICA_STATUS.DIVERGENTE.getValue():
        messageColor = MESSAGE_COLOR.ERROR;
        if (impactoOriginal === true || impactoRecomendado === true) {
          hint = 'Divergente, com impacto em tributação';
        } else if (impactoOriginal === false && impactoRecomendado === false) {
          hint = 'Divergente, sem impacto em tributação';
        }
        break;
      case ANALISE_AUTOMATICA_STATUS.DUPLICADO.getValue():
        messageColor = MESSAGE_COLOR.PRIMARY;
        break;
      case ANALISE_AUTOMATICA_STATUS.SEM_DIVERGENCIA.getValue():
        messageColor = MESSAGE_COLOR.DEFAULT;
        hint = null;
        break;
    }

    return {
      messageColor: messageColor,
      hint: hint,
    };
  }

  static getEstiloCampo(
    valorOriginal,
    valorRecomendado,
    statusOriginal,
    impactoOriginal = null,
    impactoRecomendado = null,
  ) {
    const statusExibicao = UtilsAnalise.getStatusExibicao(valorOriginal, valorRecomendado, statusOriginal);
    return UtilsAnalise.getEstiloCampoPorStatus(statusExibicao, impactoOriginal, impactoRecomendado);
  }

  static getPresetCampoPorStatus(status) {
    switch (status) {
      case ANALISE_AUTOMATICA_STATUS.OPCIONAL.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_OPCIONAL.getValue();
      case ANALISE_AUTOMATICA_STATUS.EXCECAO.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_EXCECAO.getValue();
      case ANALISE_AUTOMATICA_STATUS.DIVERGENTE.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_DIVERGENTE.getValue();
      case ANALISE_AUTOMATICA_STATUS.INVALIDO.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_INVALIDO.getValue();
      case ANALISE_AUTOMATICA_STATUS.DUPLICADO.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_DUPLICADO.getValue();
      case ANALISE_AUTOMATICA_STATUS.EXPIRADO.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_EXPIRADO.getValue();
      case ANALISE_AUTOMATICA_STATUS.INATIVO.getValue():
        return AG_INPUT_FIELD_PRESET.ANALISE_INATIVO.getValue();
      default:
        return null;
    }
  }

  static getPresetCampo(valorOriginal, valorRecomendado, statusOriginal, { messageColor = null, hint = null } = {}) {
    const statusExibicao = UtilsAnalise.getStatusExibicao(valorOriginal, valorRecomendado, statusOriginal, {
      messageColor,
      hint,
    });

    return UtilsAnalise.getPresetCampoPorStatus(statusExibicao);
  }

  static possuiCampoImproprioParaUso(statusCampo) {
    return [
      RUBRICA_ANALISE_AUTOMATICA_STATUS.INATIVO,
      RUBRICA_ANALISE_AUTOMATICA_STATUS.INVALIDO,
      RUBRICA_ANALISE_AUTOMATICA_STATUS.EXPIRADO,
    ].includes(statusCampo);
  }
}
